/**
 * Technology CRUD
 */

import type { Technology } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateTechnologyInput {
  name: string;
  description?: string;
  productFamilyId?: string;
  version?: string;
  lifecycleStage?: string;
  supplierId?: string;
  licenseType?: string;
  supportEndDate?: string;
  securityRating?: string;
  replacesId?: string;
  replacedById?: string;
  tags?: string[];
  notes?: string;
}

export interface UpdateTechnologyInput {
  name?: string;
  description?: string;
  productFamilyId?: string;
  version?: string;
  lifecycleStage?: string;
  supplierId?: string;
  licenseType?: string;
  supportEndDate?: string;
  securityRating?: string;
  replacesId?: string;
  replacedById?: string;
  tags?: string[];
  notes?: string;
}

const client = createEntityCrudClient<Technology, CreateTechnologyInput, UpdateTechnologyInput>(
  '/technologies'
);

export async function createTechnology(input: CreateTechnologyInput): Promise<Technology> {
  return client.create(input);
}

export async function updateTechnology(
  technologyId: string,
  input: UpdateTechnologyInput
): Promise<Technology> {
  return client.update(technologyId, input);
}

export async function deleteTechnology(
  technologyId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(technologyId, hardDelete);
}
